import React from 'react';
import { Img } from './logoimage.style.js';
import logo from './logo.svg';

export const LogoImage = (props) => {
  return <Img alt="Logo" {...props} src={logo} />;
};

export default LogoImage;
